import { Fragment } from 'react';
import { NextSeo } from 'next-seo';
import ContactForm from '../components/form/contactForm';
import Socials from '../components/blog/social';
import { withAnimation } from '../utils/hoc';
import { socials } from '../utils/constants';

function ContactPage(params) {
	return (
		<>
			<NextSeo title="Contact Page" titleTemplate="%s | Alaeddine Messadi" />

			<section className="hero is-fullheight" style={{ display: 'block' }}>
				<div className="hero-body stars">
					<div className="small" />
					<div className="medium" />
					<div className="big" />
					<div className="container has-text-centered">
						<div className="columns is-8 is-variable ">
							<div className="column is-one-thirds has-text-left">
								<h1 className="title is-1">CONTACT ME</h1>
								<p className="is-size-4">
									How can technology help you to realise your ambitions?
									<br /> <br /> Get in touch and let's find out.
								</p>
								<br />
								<Socials list={socials} />
							</div>
							<div className="column is-two-third has-text-left">
								<ContactForm />
							</div>
						</div>
					</div>
					<div className="waves" />
				</div>
			</section>
		</>
	);
}

export default withAnimation(ContactPage);
